import { useEffect, useState } from "react";

export default function SettingsField({
  label,
  type,
  value,
  disabled,
  onChange,
  confirmText,
}) {
  // Load user profile settings into the state
  // Do a deep compare to see if anything is different
  const [localValue, setLocalValue] = useState(value);
  useEffect(() => {
    setLocalValue(value);
  }, [value]);
  return (
    <div className="w-full">
      <label className="block text-xs text-gray-700 font-semibold">
        {label}
      </label>
      <input
        onChange={(e) => {
          setLocalValue(e.target.value);
          onChange(e);
        }}
        type={type || "text"}
        disabled={disabled}
        value={localValue}
        className={`border mt-1 bg-white shadow-sm border-gray-300 rounded-md text-sm w-full ${
          disabled ? "text-gray-400" : ""
        }`}
      />
    </div>
  );
}
